export default "__VITE_ASSET__BxOwgBO8__"